import { render } from "./ContenutoOrdine.vue?vue&type=template&id=9016d582"
import script from "./ContenutoOrdine.vue?vue&type=script&lang=js"
export * from "./ContenutoOrdine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__